'use strict';

(function() { // jshint ignore:line
    angular.module('itxApp.header').factory('ItxApiSvc', ['$q', function($q) {
 

        var promises = {};


var typeCatalog = inditex.iIsMobile ? 5 : 1;

        return {
            getCategoryTree:function(){
                return this.getiCategoryTreeJSON();
            },
            getiCategoryTreeJSON: function() {
                
                
                if (!promises['getiCategoryTreeJSON']) {
                    
                    var deferred = $q.defer();
                    promises['getiCategoryTreeJSON'] = deferred.promise;
                    if(inditex.iCategoryTreeJSON){
                        
                         deferred.resolve(inditex.iCategoryTreeJSON);
                    }
                    else{


                    
                    var actions = [];
                        actions.push({
                            'action': 'catalog:categories',
                            'params': {
                                'storeId': inditex.iStoreId,
                                'languageId': inditex.iLangId,
                                'catalogId': inditex.iCatalogId,
                                'typeCatalog': typeCatalog
                            }
                        });
                        inditex.execute({
                            'actions': actions,
                            'onFinish': function() {
                                deferred.resolve(inditex.iCategoryTreeJSON);
                            }
                        });
                    }
                }


                return promises['getiCategoryTreeJSON'];

            }
        };
    }]);

})();